module.exports = __webpack_public_path__ + "static/media/cablecircle3.923789c0.png";